import _curry3 from "./internal/_curry3.js";
var assoc = _curry3(function assoc(prop, val, obj) {
    var result = {};
    for (var p in obj) {
        result[p] = obj[p];
    }
    result[prop] = val;
    return result;
});
export default assoc;
